import { useEffect } from 'react';
import { connect } from 'react-redux';
import { setCardHeight } from 'client/actions';
import { COMPONENT_TYPE } from 'common/constants';
import { CARD_ROOT_ID, STORY_ELEMENTS_ID } from 'client/constants/common';
import { ClientReducerState } from 'src/routes/client/reducers';

function Observer(this: any, callback, autoHeight?: boolean) {
	this.height = null;
	this.rafID = 0;

	const { body } = document;
	const items: (HTMLElement | null)[] = [
		document.getElementById(CARD_ROOT_ID),
		document.querySelector(`#${CARD_ROOT_ID} [data-bb="${COMPONENT_TYPE.FLOAT_ABOVE}"]`),
		document.querySelector(`#${CARD_ROOT_ID} [data-bb="${COMPONENT_TYPE.FLOAT_BELOW}"]`),
		document.querySelector(`#${STORY_ELEMENTS_ID} [data-bb="${COMPONENT_TYPE.FLOAT_ABOVE}"]`),
		document.querySelector(`#${STORY_ELEMENTS_ID} [data-bb="${COMPONENT_TYPE.FLOAT_BELOW}"]`),
	];

	this.observe = () => {
		// parentElement is for to get height including Content margins
		const contentHeight =
			document.querySelector(`[data-bb="${COMPONENT_TYPE.CONTENT}"]`)?.parentElement?.clientHeight ?? 0;
		let height = Math.max(contentHeight, window.innerHeight);

		if (autoHeight) {
			height = contentHeight;
		}

		if (height !== this.height) {
			this.height = height;
			// it is required to have a height so that the <SelectionHint> can occupy only this allowed height
			// and when passing beyond it do not create additional scrolling
			body.style.height = `${height}px`;
			body.style.position = `relative`;

			/* eslint-disable no-param-reassign */
			items.forEach(item => {
				if (item) item.style.height = `${height}px`;
			});
			/* eslint-enable no-param-reassign */

			callback(height);
		}
		this.rafID = window.requestAnimationFrame(this.observe);
	};
}

type CardHeightObserverProps = {
	autoHeight?: boolean;
	setCardHeight: (...args: any[]) => any;
};

const CardHeightObserver = (props: CardHeightObserverProps) => {
	useEffect(() => {
		const observer = new Observer(props.setCardHeight, props.autoHeight);
		const { observe } = observer;
		observer.rafID = window.requestAnimationFrame(observe);
		return () => {
			window.cancelAnimationFrame(observer.rafID);
		};
	}, [props.setCardHeight, props.autoHeight]);

	return null;
};

export default connect((state: ClientReducerState) => ({ autoHeight: state.settings.embed.autoHeight }), {
	setCardHeight,
})(CardHeightObserver);
